import { API_ENDPOINTS, BASE_URL } from '../../constants/apiEndpoints';
import fetcher from '../../helpers/fetcher';

export interface NewsItem {
  id: number;
  title: string;
  summary: string;
  description: string;
  preview: string;
  isActive: boolean;
  userId: string;
  createTime: number;
  updateTime: number;
}

export interface NewsResponse {
  data: NewsItem[];
  total: number;
  page: number;
  limit: number;
}

export interface CreateNewsDto {
  title: string;
  summary: string;
  description: string;
  preview: string;
  isActive?: boolean;
  userId?: string;
}

export interface UpdateNewsDto {
  title?: string;
  summary?: string;
  description?: string;
  preview?: string;
  isActive?: boolean;
  userId?: string;
}

export const getNews = (page: number = 1, limit: number = 100): Promise<NewsItem[]> => {
  return fetcher
    .get(API_ENDPOINTS.NEWS.GET_PUBLIC_NEWS, { page, limit }, {}, BASE_URL.ANALYSIS_SERVICE_BASE)
    .then((response) => {
      if (response.data && typeof response.data === 'object' && response.data.data) {
        return Array.isArray(response.data.data) ? response.data.data : [];
      }
      return Array.isArray(response.data) ? response.data : [];
    });
};

export const getNewsById = (id: number): Promise<NewsItem> => {
  return fetcher
    .get(`${API_ENDPOINTS.NEWS.GET_PUBLIC_NEWS_BY_ID}/${id}`, {}, {}, BASE_URL.ANALYSIS_SERVICE_BASE)
    .then((response) => {
      return response.data;
    });
};

export const createNews = (newsData: CreateNewsDto): Promise<NewsItem> => {
  return fetcher
    .post(API_ENDPOINTS.NEWS.CREATE_NEWS, newsData, {}, BASE_URL.CONSUMER_PRICE_BASE)
    .then((response) => {
      return response.data;
    });
};

export const updateNews = (id: number, newsData: UpdateNewsDto): Promise<NewsItem> => {
  return fetcher
    .patch(`${API_ENDPOINTS.NEWS.UPDATE_NEWS}/${id}`, newsData, {}, BASE_URL.CONSUMER_PRICE_BASE)
    .then((response) => {
      return response.data;
    });
};

export const deleteNews = (id: number): Promise<void> => {
  return fetcher
    .del(`${API_ENDPOINTS.NEWS.DELETE_NEWS}/${id}`, {}, {}, BASE_URL.CONSUMER_PRICE_BASE)
    .then(() => {
      return;
    });
};

export const getPublicNews = (page: number = 1, limit: number = 3): Promise<NewsResponse> => {
  return fetcher
    .get(API_ENDPOINTS.NEWS.GET_PUBLIC_NEWS, { page, limit }, {}, BASE_URL.ANALYSIS_SERVICE_BASE)
    .then((response) => {
      return response.data;
    });
};
